(() => {
  if (customElements.get("product-media")) {
    return;
  }

  class ProductMedia extends HTMLElement {
    constructor() {
      super();

      this.mainSliderElement = this.querySelector("[data-main-product-slider]");
      this.mainSliderDrag =
        Number(this.mainSliderElement.dataset.slidesCount) !== 1;
      this.autoHeight = this.hasAttribute("data-autoheight");
      this.mainSlider = {
        element: this.mainSliderElement,
        bar: this.querySelector("[data-main-product-slider-progress-bar]"),
        instance: null,
        options: {
          type: "fade",
          pagination: false,
          rewind: true,
          waitForTransition: true,
          flickMaxPages: 0.5,
          arrows: false,
          drag: this.mainSliderDrag,
          speed: 300,
          easing: "ease-in-out",
        },
      };
      this.thumbsSlider = {
        element: this.querySelector("[data-main-product-thumbs]"),
        nextArrow: this.querySelector("[data-thumbs-next]"),
        instance: null,
        options: {
          pagination: false,
          rewind: true,
          waitForTransition: true,
          flickMaxPages: 0.5,
          arrows: false,
          isNavigation: true,
          direction: "ttb",
          fixedWidth: "9.6rem",
          height: "55.1rem",
          autoHeight: true,
          perPage: 4,
          gap: "0.6rem",
          speed: 300,
          easing: "ease-in-out",
          breakpoints: {
            640: {
              fixedWidth: "",
              height: "auto",
              flickMaxPages: 1,
              direction: "ltr",
              perPage: 3,
            },
          },
        },
      };
      this.controls = this.querySelectorAll("[data-control]");

      this.controls.forEach((control) => {
        control.addEventListener("click", this.onControlClick.bind(this));
      });

      if (this.thumbsSlider.nextArrow) {
        this.thumbsSlider.nextArrow.addEventListener("click", (event) => {
          this.onControlClick(event, this.thumbsSlider.instance);
        });
      }

      window.addEventListener("DOMContentLoaded", this.initSlider.bind(this));

      // window.addEventListener(debounce(this.initSlider.bind(this), 500))

      window.addEventListener("resize", () => {
        console.log("height changes");
        this.initSlider.bind(this);

        if (this.mainSlider.instance) {
          const slides = Array.from(
            this.mainSlider.instance.Components.Elements.slides,
          );
          slides.forEach((slide) => {
            slide.style.height = "";
          });
        }

        this.initSlider();

        if (this.mainSlider.instance) {
          const slides = Array.from(
            this.mainSlider.instance.Components.Elements.slides,
          );
          this.setUniformHeight(slides);
        }
      });
    }

    connectedCallback() {
      this.initSlider();

      document.body.addEventListener(
        "touchstart",
        () => {
          this.querySelectorAll("deferred-media[data-autoplay]").forEach(
            (media) => {
              const iframe = media.querySelector("iframe");

              if (!iframe) return;

              if (iframe.classList.contains("js-youtube")) {
                iframe.contentWindow.postMessage(
                  '{"event":"command","func":"' + "playVideo" + '","args":""}',
                  "*",
                );
              }

              if (iframe.classList.contains("js-vimeo")) {
                iframe.contentWindow.postMessage('{"method":"play"}', "*");
              }
            },
          );
        },
        { once: true },
      );
    }

    setUniformHeight(slides) {
      if (!slides || slides.length === 0) return;

      if (window.innerWidth < 768) {
        slides.forEach((slide) => {
          const width = slide.offsetWidth;
          slide.style.height = `${width}px`;
        });
      } else {
        const tallestHeight = Math.max(
          ...slides.map((slide) => slide.offsetHeight),
        );
        slides.forEach((slide) => {
          slide.style.height = `${tallestHeight}px`;
        });
      }
    }

    onControlClick(event, sliderInstance = this.mainSlider.instance) {
      event.preventDefault();

      if (!sliderInstance) {
        return;
      }

      const action = event.target.hasAttribute("data-prev") ? "<" : ">";

      sliderInstance.go(action);
    }

    initSlider() {
      if (
        window.innerWidth >= 990 &&
        !this.mainSlider.element.hasAttribute("data-main-slider-desktop")
      ) {
        this.mainSlider.element.classList.add("is-initialized");

        if (this.mainSlider.instance) {
          this.mainSlider.instance.destroy(true);
          this.mainSlider.instance = null;
        }

        return;
      }

      if (this.mainSlider.instance) {
        return;
      }

      if (this.thumbsSlider.element) {
        this.thumbsSlider.instance = new Splide(
          this.thumbsSlider.element,
          this.thumbsSlider.options,
        ).mount();
      }

      this.mainSlider.instance = new Splide(
        this.mainSlider.element,
        this.mainSlider.options,
      );

      if (this.autoHeight) {
        this.mainSlider.instance.on("mounted", () => {
          const slides = Array.from(
            this.mainSlider.instance.Components.Elements.slides,
          );
          this.setUniformHeight(slides);
        });

        this.mainSlider.instance.on("moved", () => {
          const slides = Array.from(
            this.mainSlider.instance.Components.Elements.slides,
          );
          this.setUniformHeight(slides);
        });
      }

      if (this.mainSlider.bar) {
        this.mainSlider.instance.on("mounted move", () => {
          const sliderEnd =
            this.mainSlider.instance.Components.Controller.getEnd() + 1;
          this.mainSlider.bar.style.width = `${(100 * (this.mainSlider.instance.index + 1)) / sliderEnd}%`;
        });
      }

      this.thumbsSlider.instance
        ? this.mainSlider.instance.sync(this.thumbsSlider.instance).mount()
        : this.mainSlider.instance.mount();
    }

    changeListHeight(rootEl, slides) {
      rootEl.querySelector(".splide__list").style.height =
        `${slides.find((slide) => slide.classList.contains("is-active")).offsetHeight}px`;
    }

    goToSlide(mediaId) {
      if (!this.mainSlider.element) {
        console.error("Main slider element not found.");
        return;
      }

      // if (window.innerWidth < 990) {
      // Mobile behavior: Scroll to the selected slide
      if (!this.mainSlider.instance) {
        const media = this.mainSlider.element.querySelector(
          `[data-media-id="${mediaId}"]`,
        );

        if (!media) {
          return;
        }

        media.scrollIntoView({
          behavior: "smooth",
        });

        return;
      }

      const slideIndex = this.mainSlider.instance.s.Elements.slides.findIndex(
        (slide) => slide.dataset.mediaId === mediaId.toString(),
      );

      this.mainSlider.instance.go(slideIndex);
      return;
      // }

      // Desktop behavior: Replace the first slide if it has book-attribute
      // const slides = Array.from(
      //     this.mainSlider.element.querySelectorAll("[data-product-media]")
      // )

      // const firstSlide = slides[0]

      // let selectedSlide

      // if (typeof mediaId === "string") {
      //     selectedSlide = slides.find(
      //         (slide) => slide.dataset.mediaId === mediaId
      //     )
      // } else {
      //     selectedSlide = slides.find(
      //         (slide) => Number(slide.dataset.mediaId) === mediaId
      //     )
      // }

      // if (!firstSlide || !selectedSlide) {
      //     console.error(
      //         "Either the first slide or the selected slide could not be found."
      //     )
      //     return
      // }

      // // Lock the container height to prevent layout shifts
      // const sliderList =
      //     this.mainSlider.element.querySelector(".splide__list")
      // sliderList.style.height = `${firstSlide.offsetHeight}px`

      // // Add a fade-out effect
      // firstSlide.style.transition = "opacity .1s ease"
      // selectedSlide.style.transition = "opacity .1s ease"

      // firstSlide.style.opacity = "0"
      // selectedSlide.style.opacity = "0"

      // setTimeout(() => {
      //     // Swap the contents after fade-out
      //     const tempContent = firstSlide.innerHTML
      //     firstSlide.innerHTML = selectedSlide.innerHTML
      //     selectedSlide.innerHTML = tempContent

      //     // Swap the media IDs to maintain correct references
      //     const tempId = firstSlide.dataset.mediaId
      //     firstSlide.dataset.mediaId = selectedSlide.dataset.mediaId
      //     selectedSlide.dataset.mediaId = tempId

      //     // Fade-in effect
      //     firstSlide.style.opacity = "1"
      //     selectedSlide.style.opacity = "1"

      //     // Remove the locked height after the transition
      //     setTimeout(() => {
      //         sliderList.style.height = "auto"
      //     }, 300) // Match the transition duration

      //     // Refresh the slider if it's initialized
      //     if (this.mainSlider.instance) {
      //         this.mainSlider.instance.refresh()
      //     }
      // }, 100) // Match the duration of the fade-out transition
    }
  }

  customElements.define("product-media", ProductMedia);
})();
